import { unref, type MaybeRef } from 'vue'
import { computedAsync, type AsyncComputedOptions } from '@vueuse/core'
import { getGlobalSearchResults } from '@/api'
import type { GlobalSearchItems } from '@/types'

export const useGlobalSearchAsync = (
    searchTerm: MaybeRef<string>,
    pageNumber: MaybeRef<number>,
    pagesSize: MaybeRef<number>,
    contentTypeKeys?: MaybeRef<string[]>,
    options?: AsyncComputedOptions
) => {
    return computedAsync<GlobalSearchItems>(
        async (onCancel) => {
            const abortController = new AbortController()

            onCancel(() => abortController.abort())

            return getGlobalSearchResults(
                unref(searchTerm),
                unref(pageNumber),
                unref(pagesSize),
                unref(contentTypeKeys),
                abortController.signal
            )
        },
        undefined,
        options,
    )
}
